export interface ConversionTotals {
  totalEncounters: number;
  createdPrevisits: number;
  deliveredPrevisits: number;
  startedPrevisits: number;
  finishedPrevisits: number;
  name: string;
}

export interface FeedbackTotals {
  positiveCount: number;
  negativeCount: number;
  name: string;
}

export interface NotificationTotals {
  sent: number;
  sentEmail: number;
  sentSms: number;
  total: number;
  totalEmail: number;
  totalSms: number;
  name: string;
}

export enum ConversionGroupBy {
  Age = 'age',
  Organization = 'organization',
  Practice = 'practice',
}

interface Option {
  id: string;
  value: string;
}

export type FilterOptions = Record<string, Option[]>;

export interface ConversionResponse<T> {
  results: T[];
}
